import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

function TabPanel (props) {
    const { children, value, current, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== current}
            id={`scrollable-auto-tabpanel-${current}`}
            aria-labelledby={`tab-${current}`}
            {...other}>
            {value === current && (
                <Box p={1}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    value: PropTypes.any.isRequired,
    current: PropTypes.any.isRequired,
};

export default TabPanel;
